import React from 'react';
import * as S from './style';
import { Label, Row } from 'components';

export interface Props {
    label?: string;
    subLabel?: string;
    itemRadius?: number;
    children: React.ReactNode;
}

function FormItemGrid({ children, label, subLabel, itemRadius }: Props): React.ReactElement {
    return (
        <Row>
            <S.FormItemContainer>
                <S.LabelContainer>
                    <Label contents={label} fontStyle={'body2'} color={'gray_opacity_800'} />
                    {subLabel ? (
                        <S.LabelWrapper>
                            <Label contents={subLabel} fontStyle={'subtitle'} color={'gray_opacity_600'} />
                        </S.LabelWrapper>
                    ) : null}
                </S.LabelContainer>
                <S.ChildrenWrapper itemRadius={itemRadius}>{children}</S.ChildrenWrapper>
            </S.FormItemContainer>
        </Row>
    );
}

export default FormItemGrid;
